<template>
  <ClientOnly>
    <IaNotificationToast />
  </ClientOnly>
</template>
